export const API = "https://demo.daugiayahoo.jp"
// export const API = "http://localhost:5500"
